import { render } from "./ClinicianHolds.vue?vue&type=template&id=77197895&scoped=true"
import script from "./ClinicianHolds.vue?vue&type=script&lang=js"
export * from "./ClinicianHolds.vue?vue&type=script&lang=js"

import "./ClinicianHolds.vue?vue&type=style&index=0&id=77197895&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77197895"]])

export default __exports__